import React, {useEffect, useState} from 'react';
import { properties } from '../../properties';
import SoapResponse from "../SoapResponse";
import ErrorPage from '../../ErrorPage';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import $ from "jquery";

function SoapTokenSettle({ apiUrl }) {
    const [soapTokenSettle, setSoapTokenSettle] = useState({
        operation: properties.OPERATIONS.tokenSettle,
        vendorid: properties.VENDOR_ID,
        transactionid: transidgenerator(),
        userid: properties.USER_ID,
        method: properties.SOAP_METHOD,
        customerPresent: properties.CUSTOMER_PRESENT,
        token: properties.TOKEN,
        authCode: properties.AUTHCODE,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        timestamp: "",
        region: properties.SEL_REGION,
        password: properties.PASSWORD,
        security: ""
    });
 
    var canSubmit = true;
 
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    const [response, setResponse] = useState();

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setSoapTokenSettle({ ...soapTokenSettle, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setSoapTokenSettle({ ...soapTokenSettle, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setSoapTokenSettle({ ...soapTokenSettle, password: e.target.value });
    }

    function changeMethod(e) {
        isNotNullCheck(e.target.value,"WPG_method");
        setSoapTokenSettle({ ...soapTokenSettle, method: e.target.value });
    }

    function changeDesc(e) {
        isNotNullCheck(e.target.value,"WPG_description");
        setSoapTokenSettle({ ...soapTokenSettle, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setSoapTokenSettle({ ...soapTokenSettle, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setSoapTokenSettle({ ...soapTokenSettle, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setSoapTokenSettle({ ...soapTokenSettle, token: e.target.value });
    }

    function changeAuthCode(e) {
        isNotNullCheck(e.target.value,"WPG_authCode");
        setSoapTokenSettle({ ...soapTokenSettle, authCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setSoapTokenSettle({ ...soapTokenSettle, region: e.target.value });
    }

    function changeUserId(e) {
        setSoapTokenSettle({ ...soapTokenSettle, userid: e.target.value });
    }

    function changeCustomerPresent(e) {
        isNotNullCheck(e.target.value,"WPG_customerPresent");
        setSoapTokenSettle({ ...soapTokenSettle, customerPresent: e.target.value });
    }

    var region =[];
 
    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    async function submitTokenSettleForm(e) {
        e.preventDefault();
        isNotNullCheck(soapTokenSettle.transactionid,"WPG_transID");
        isNotNullCheck(soapTokenSettle.vendorid,"WPG_vendorID");
        isNotNullCheck(soapTokenSettle.password,"vendorPwd");
        isNotNullCheck(soapTokenSettle.description,"WPG_description");
        isNotNullCheck(soapTokenSettle.method,"WPG_method");
        isNotNullCheck(soapTokenSettle.customerPresent,"WPG_customerPresent");
        isNotNullCheck(soapTokenSettle.value,"WPG_value");
        isNotNullCheck(soapTokenSettle.region,"WPG_region");
        isNotNullCheck(soapTokenSettle.token,"WPG_token");
        isNotNullCheck(soapTokenSettle.authCode,"WPG_authCode");
        isNotNullCheck(soapTokenSettle.currency,"WPG_currency");
        soapTokenSettle.timestamp = Math.floor(Date.now() / 1000);
        soapTokenSettle.timestamp = Math.floor(Date.now() / 1000);
        var md5 = require('md5');
        const requestbody =
        {
            vendorID: soapTokenSettle.vendorid,
            transID: soapTokenSettle.transactionid,
            userID: soapTokenSettle.userid,
            method: soapTokenSettle.method,
            customerPresent: soapTokenSettle.customerPresent,
            token: soapTokenSettle.token,
            authCode: soapTokenSettle.authCode,
            description: soapTokenSettle.description,
            value: soapTokenSettle.value,
            currency: soapTokenSettle.currency,
            timestamp: soapTokenSettle.timestamp,
            region: soapTokenSettle.region,
            security: md5(soapTokenSettle.vendorid +
                soapTokenSettle.transactionid + soapTokenSettle.userid +
                soapTokenSettle.method + soapTokenSettle.customerPresent +
                soapTokenSettle.token + soapTokenSettle.authCode +
                soapTokenSettle.description +
                soapTokenSettle.value + soapTokenSettle.currency +
                soapTokenSettle.timestamp + soapTokenSettle.region + 
                 soapTokenSettle.password),
            
        };
        var xmlBody = [];
        xmlBody.push(properties.SOAP_REQUEST_PREFIX + "<ns1:tokenSettle>");
        for (var property in requestbody) {
            xmlBody.push("<" + property + ">" + requestbody[property] + "</" + property + ">");
        }
        xmlBody.push("</ns1:tokenSettle>" + properties.SOAP_REQUEST_SUFFIX);
        xmlBody = xmlBody.join("\n");
        var request = {
            method: 'POST',
            headers: new Headers({
                'Accept-Type': 'text/xml',
                'Content-Type': 'text/xml'
            }),
            body: xmlBody
        };
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            var statusCode;
            if(soapTokenSettle.region === "NoR"){
                setSoapTokenSettle({...soapTokenSettle, region:""});
            }
            fetch(apiUrl, request)
            .then(resp => {
                if(Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(resp.status)) === -1){
                    return resp.text();
                }
                else{
                    statusCode = resp.status;
                    throw resp;
                }
            })
            .then(responsedata => setResponse(<SoapResponse title="Token Settle Response" operation="WPG_tokensettle" message={responsedata} />))
            .catch((error)=>{
                console.log(error);
                setResponse(<ErrorPage code={statusCode} />);
            });
        }
    }
    
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var soapTokenSettleTemplate = (
        <div className="operation-form">
            <h2>Token Settle</h2>
            <form className="form-horizontal" method='post' onSubmit={submitTokenSettleForm}>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={soapTokenSettle.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={soapTokenSettle.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        User ID
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_userid" value={soapTokenSettle.userid} onChange={changeUserId} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Present<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_customerPresent" value={soapTokenSettle.customerPresent} onChange={changeCustomerPresent}>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                        </select>
                        <div className="error-msg" name="WPG_customerPresent">Customer Present is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Method<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_method" value={soapTokenSettle.method} onChange={changeMethod} />
                        <div className="error-msg" name="WPG_method">Method is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={soapTokenSettle.description} onChange={changeDesc} />
                        <div className="error-msg" name="WPG_description">Description is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={soapTokenSettle.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={soapTokenSettle.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={soapTokenSettle.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={soapTokenSettle.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Auth Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_authCode" value={soapTokenSettle.authCode} onChange={changeAuthCode} />
                        <div className="error-msg" name="WPG_authCode">Auth Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={soapTokenSettle.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" id="tokensettleButton" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>

    );

    return response ? response : soapTokenSettleTemplate;
}

export default SoapTokenSettle;